import { FC, Fragment } from 'react';
import ScaleLoader from "react-spinners/ScaleLoader";
import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        overlay: {
            width: "100%",
            minHeight: "100vh",
            height: "100%",
            position: "absolute",
            background: "rgba(0,0,0,0.3)",
            top: 0,
            left: 0,
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            [theme.breakpoints.down("xs")]: {
                minHeight: "calc(100vh - 62px)",
                height: "calc(100vh - 62px)",
            }
        },
        loader: {
            height: 45,
        }
    })
)

interface LoadingOverlayProps {
    isLoading: boolean,
}

const LoadingOverlay: FC<LoadingOverlayProps> = (props: LoadingOverlayProps) => {
    const classes = useStyles();
    if (props.isLoading) {
        document.body.style.overflow = "hidden";
        return (
            <div className={classes.overlay}>
                <div className={classes.loader}>
                    <ScaleLoader color="#53457C" height={45} width={6} radius={0} margin={3} />
                </div>
            </div>
        )
    }

    document.body.style.overflow = "visible";
    document.body.style.overflowX = "hidden";
    return (
        <Fragment></Fragment>
    )
}

export default LoadingOverlay;